<div *ngIf="!map" class="search-field {{ isMobile ? 'sf-sp' : '' }}">
  <mat-form-field
    class="search-field-form"
    appearance="fill"
    (keyup.enter)="filter($event)"
  >
    <button
      *ngIf="isMobile"
      mat-icon-button
      matPrefix
      color="accent"
      (click)="filter($event); router.navigate(['/carte'])"
    >
      <mat-icon>search</mat-icon>
    </button>
    <mat-label translate="">Search</mat-label>
    <input
      matInput
      type="search"
      [(ngModel)]="value"
      autocomplete="off"
      placeholder="{{ 'FilterSearchPlaceHolder' | translate }}"
      (keyup)="keyword($event)"
    />
    <button
      [ngClass]="value ? '' : 'hide-button'"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="
        value = ''; filter($event); keyWords.emit([]); kwHidden.emit(true)
      "
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<div
  *ngIf="map"
  class="search-field search-field-map  {{ isMobile ? 'sf-sp map-sf-sp' : '' }}"
>
  <mat-form-field appearance="fill" (keyup.enter)="filter($event)">
    <button mat-icon-button matPrefix color="accent" (click)="filter($event)">
      <mat-icon>search</mat-icon>
    </button>
    <mat-label translate="">Search</mat-label>
    <input
      matInput
      type="search"
      [(ngModel)]="value"
      autocomplete="off"
      placeholder="{{ 'FilterSearchPlaceHolder' | translate }}"
    />
    <button
      mat-chip
      class="generic-button search-filter"
      matSuffix
      (click)="openFilter()"
      color="primary"
    >
      <mat-icon matBadge="{{ filterCount }}" [matBadgeHidden]="filterCount < 1"
        >tune</mat-icon
      >
    </button>
  </mat-form-field>
</div>
